// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Trash(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Trash" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 1.5H7.5V3H1.5V6H3.75L4.5 22.5H19.3636L20.25 6H22.5V3H16.5V1.5ZM7.5 7.5H9V19.5H7.5V7.5ZM11.25 7.5H12.75V19.5H11.25V7.5ZM15 7.5H16.5V19.5H15V7.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Trash.js.map